import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ToastService } from 'src/app/shared/services/toast/toast.service';
import { Chunk } from '../../chunk.dto';
import { ChunkService } from '../../chunk.service';

@Component({
  selector: 'app-generate-embeddings-option',
  standalone: true,
  imports: [TranslateModule, MatIconModule],
  template: `
    <div class="interactive-item" (click)="generateEmbeddings()">
      <div class="interactive-item__content">
        <mat-icon class="interactive-item__icon" aria-hidden="true">database_search</mat-icon>
        <span class="interactive-item__text">{{
          (chunk.isReadyForIndexing ? 'ChunkDisplayer.chunkOptions.GenerateEmbeddings' : 'ChunkDisplayer.chunkOptions.RegenerateEmbeddings') | translate
        }}</span>
      </div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GenerateEmbeddingsOptionComponent {
  @Input() chunk: Chunk;
  @Output() actionTriggered = new EventEmitter<void>();

  private chunkService = inject(ChunkService);
  private toast = inject(ToastService);
  private translate = inject(TranslateService);

  generateEmbeddings(): void {
    this.actionTriggered.emit();
    if (!this.chunk) {
      return;
    }

    this.chunkService.triggerGenerateEmbeddings(this.chunk._id).subscribe({
      complete: () => {
        this.chunkService.passChunkEditEvent(this.chunk._id);
        this.toast.snackbar.open(this.translate.instant('Snackbar.Done'), 'OK', {
          duration: 2000,
        });
      },
      error: (err) => {
        console.error(err);
        this.toast.snackbar.open(this.translate.instant('Snackbar.EmbeddingGenerationFail'), 'OK', {
          duration: 2000,
        });
      },
    });
  }
}
